import { auth, twitterAuthProvider } from "../../utils/firebase";
import { ls } from "../../reducers/auth/action";
import { getAnalytics, logEvent } from "firebase/analytics";
import { signInWithRedirect, getRedirectResult, signOut } from "firebase/auth";
import * as Sentry from "@sentry/react";
import Spinner from "../../components/spinner/Spinner.component";
import { TwitterCredApi } from "../../Network/network";

const DiamondLoginTwitter = () => {
  let i = 0;
  const analytics = getAnalytics();

  if (i === 0) {
    i++;

    getRedirectResult(auth)
      .then((result) => {
        if (!result?.user) {
          signInWithRedirect(auth, twitterAuthProvider)
            .then((r) => {
              console.log(r);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          let bodyData = {
            twitter_user_id: result?.user?.providerData?.[0]?.uid,
            access_token_secret: result?._tokenResponse?.oauthTokenSecret,
            access_token: result?._tokenResponse?.oauthAccessToken,
            refresh_token: result?.user?.stsTokenManager?.refreshToken,
          };
          TwitterCredApi(bodyData).then((res) => {
          ls.set("twitter", result?.user);
          localStorage.setItem(
            "twitter_username",
            result?.user?.reloadUserInfo?.screenName
          );
          logEvent(analytics, "twitter_login", {
            user_id: result?.user?.uid,
            user_name: result?.user?.displayName,
          });
          let message = {
            twitter_user_id: result?.user?.providerData[0]?.uid,
            twitter_username: result?.user?.reloadUserInfo?.screenName,
            twitter_user_profile_image: result?.user?.photoURL,
          };
          window.opener.postMessage(message, "http://localhost:3000/");
          window.opener.postMessage(message, "https://web3setu.com");
          window.opener.postMessage(message, "http://localhost:63342/");
          window.opener.postMessage(message, "https://diamondapp.com");
          window.opener.postMessage(message, "https://dev.diamondapp.com");
          window.close();
          }).catch((err) => {
            console.log(err);
            ls.set("twitter", result?.user);
          localStorage.setItem(
            "twitter_username",
            result?.user?.reloadUserInfo?.screenName
          );
          logEvent(analytics, "twitter_login", {
            user_id: result?.user?.uid,
            user_name: result?.user?.displayName,
          });
          let message = {
            twitter_user_id: result?.user?.providerData[0]?.uid,
            twitter_username: result?.user?.reloadUserInfo?.screenName,
            twitter_user_profile_image: result?.user?.photoURL,
          };
          window.opener.postMessage(message, "http://localhost:3000/");
          window.opener.postMessage(message, "https://web3setu.com");
          window.opener.postMessage(message, "http://localhost:63342/");
          window.opener.postMessage(message, "https://diamondapp.com");
          window.opener.postMessage(message, "https://dev.diamondapp.com");
          window.close();
          });
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.log(error);
      });
  }

  return <Spinner />;
};

export default DiamondLoginTwitter;
